<template>
    <div class="author-reward">
        <div class="author-reward-btn"><i class="icon i_shang"></i>我要打赏</div>
    </div>
</template>

<script>
export default {
    name: "Reward",
    props: ["info"]
}
</script>
